/**
 * 菜单页
 */
import React, { FC, useState, createContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import { restaurantConfig, storeMobx, menuMobx, restaurantCenter, RESTAURANT_EVENT } from 'restaurant'
import { queueOrderingMobx } from '@mobxStore'
import { Advert as MenuAdvert } from '@cps'
import { MenuTop, MenuHeader, SoldoutBar, MenuNoticeScroll, ProductTemplate, QueueBar, MenuNoticeFull, ShopwindowAdvert } from '../'
import { useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react'
import { useHistoryNew } from '@utils'
import './index.scss'

export const prodRecommendContent = createContext(null)

// interface
interface IProps extends IPage {
}
let saveStoreId = 0
let advertTimer = null
const MenuStyleDefault: FC<IProps> = () => {
  const { info: store } = storeMobx
  const { mealsWaitingTime = {} } = store
  const [showWaiting, setShowWaiting] = useState(true)
  const [fullNotice, setFullNotice] = useState(false)
  /** ionic 轮播有bug，切换门店，先隐藏 */
  const [hideAdvert, setHideAdvert] = useState(true)
  const history = useHistoryNew()

  const loadingAdvert = () => {
    /** 门店切换，但是非菜单页，不需要显示 */
    clearTimeout(advertTimer)
    setHideAdvert(true)
    if (saveStoreId !== storeMobx.info.storeId) {
      setHideAdvert(true)
      saveStoreId = storeMobx.info.storeId
      advertTimer = setTimeout(() => {
        setHideAdvert(false)
      }, 1000)
    } else {
      setHideAdvert(false)
    }
  }

  useEffect(() => {
    const event = restaurantCenter.on(RESTAURANT_EVENT.STORE_CHANGED, ({ type }) => {
      if (history.getRouteInfo().pathname === '/menu') {
        loadingAdvert()
      }
    })
    return () => {
      restaurantCenter.off(event)
    }
  }, [])
  useIonViewWillEnter(() => {
    loadingAdvert()
  })
  /** 其他页面也会切换门店，需要先隐藏广告 */
  useIonViewDidLeave(() => {
    setHideAdvert(true)
  })
  useEffect(() => {
    loadingAdvert()
  }, [])

  return (
    <div className='menu-style-default-container'>
      <MenuTop />
      {menuMobx.canOpenSoldout && menuMobx.openSoldoutHidden === 1 && menuMobx.openSoldout === 1 && <SoldoutBar />}
      <MenuHeader />
      {fullNotice && <MenuNoticeFull onChange={(full) => setFullNotice(full)} />}
      {!fullNotice && <MenuNoticeScroll onChange={(full) => setFullNotice(full)} />}
      {!!queueOrderingMobx.inPreQueueOrdering && <QueueBar />}
      {
        showWaiting && (typeof store?.mealsWaitingTime?.waitingTime === 'number' && typeof store?.mealsWaitingTime?.leastTime === 'number' && store?.mealsWaitingTime?.waitingTime > store?.mealsWaitingTime?.leastTime) && (store?.mealsWaitingTime?.scene && !!store?.mealsWaitingTime?.scene[restaurantConfig.codeType === 'brand' ? 'pickup' : 'dinein']) && (
          <div className='menu-waiting'>
            <p>
              <span>
                {!mealsWaitingTime?.content || mealsWaitingTime?.content?.order === 1 ? i18n.t('menu.mealsWaitingOrderNum', { cnt: mealsWaitingTime?.orderUnMealedNum }) : ''}
              </span>
              <span>
                {!mealsWaitingTime?.content || mealsWaitingTime?.content?.order === 1 && mealsWaitingTime?.content?.time === 1 ? '/' : ''}
              </span>
              <span>
                {!mealsWaitingTime?.content || mealsWaitingTime?.content?.time === 1 ? i18n.t('menu.mealsWaitingTime1', { minute: mealsWaitingTime?.waitingTime }) : ''}
              </span>
            </p>
            <i className='iconfont icon-close' onClick={() => { setShowWaiting(false) }}></i>
          </div>
        )
      }
      {!hideAdvert && <MenuAdvert type='menu' />}
      <ShopwindowAdvert useType='waterfall' />
      {/* <RecommendProducts /> */}
      <ProductTemplate />
    </div>
  )
}

export default observer(MenuStyleDefault)
